import { render, staticRenderFns } from "./Screenshotsp.vue?vue&type=template&id=9bc738a0&"
import script from "./Screenshotsp.vue?vue&type=script&lang=js&"
export * from "./Screenshotsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports